module.exports = __webpack_public_path__ + "img/task-active.08b5bab0.svg";